import store from "../../store"

export default () => {
    const localCarrinhoString = localStorage.getItem('__cart' + store.getters.catalogo.identificadorCatalogo)

    if (!localCarrinhoString) return

    const localCarrinho = JSON.parse(localCarrinhoString)

    if (localCarrinho.identificadorCatalogo == store.getters.catalogo.identificadorCatalogo) {
        if (localCarrinho.idPedido) store.dispatch('deleteLocalCart')
        else store.dispatch('loadLocalCart', localCarrinho.produtos)
    }
}